import { predicateMappings } from 'frontend/common/search-criterion/_search-criterion-predicate-config'

export function getPredicateFilterKey(attribute: string, predicate: string) {
  return `${attribute}${predicateMappings[predicate].suffix}`
}
